import AddObserverToCall from 'models/modal/add_observer_to_call';
import AddSharedSender from './add_shared_sender';
import AnswerPreview from './answer_preview';
import AttachmentPreview from './attachment_preview';
import AgentOnCallWarning from './agent_on_call_warning';
import AgentStatusReason from './agent_status_reason';
import CloseConversationWarning from './close_conversation_warning';
import CreditCardAmount from './credit_card_amount';
import CustomReportingError from './custom_reporting_error';
import DeleteCustomer from './delete_customer';
import DeleteFacebookComment from './delete_facebook_comment';
import DeleteVoiceRecording from './delete_voice_recording';
import MergeProfile from './merge_profile';
import RedactConversationItem from './redact_conversation_item';
import RedactTaskComment from './redact_task_comment';
import ReopenConversation from './reopen_conversation';
import ScheduleRecurringReport from './schedule_recurring_report';
import ShowCreditCard from './show_credit_card';
import TaskConfirmation from './task_confirmation';
import UnlinkProfile from './unlink_profile';
import UploadCsv from './upload_csv';
import WebhookVerification from './webhook_verification';

let modalClasses = [
  AddObserverToCall,
  AddSharedSender,
  AnswerPreview,
  AttachmentPreview,
  AgentOnCallWarning,
  AgentStatusReason,
  CloseConversationWarning,
  CreditCardAmount,
  CustomReportingError,
  DeleteCustomer,
  DeleteFacebookComment,
  DeleteVoiceRecording,
  MergeProfile,
  RedactConversationItem,
  RedactTaskComment,
  ReopenConversation,
  ScheduleRecurringReport,
  ShowCreditCard,
  TaskConfirmation,
  UnlinkProfile,
  UploadCsv,
  WebhookVerification,
];

export default Object.freeze(modalClasses.map(c => [c.typeName, c]));
